import { AdvisorData, RoboAdvisorData } from '../../../utils/types'

export const isAdvisorData = (data: AdvisorData | RoboAdvisorData): data is AdvisorData =>
  'advisorMatchId' in data

export const isRoboAdvisorData = (data: AdvisorData | RoboAdvisorData): data is RoboAdvisorData =>
  data.advisor?.format === 'roboadvisor'

export const isHumanAdvisorData = (data: AdvisorData | RoboAdvisorData): data is AdvisorData =>
  isAdvisorData(data) && data.advisor?.format === 'human'

export const isFirmAdvisorData = (data: AdvisorData | RoboAdvisorData): data is AdvisorData =>
  isAdvisorData(data) && data.advisor?.format === 'firm'

export const isNetworkAdvisorData = (data: AdvisorData | RoboAdvisorData): data is AdvisorData =>
  isAdvisorData(data) && data.advisor?.format === 'network'
